import { defineNuxtPlugin } from 'nuxt/app';
import { handleMagentoFetchAuthError } from '~/utils/magentoFetchAuthInterceptor';

export default defineNuxtPlugin(() => {
  if (!import.meta.client) {
    return;
  }

  globalThis.$fetch = $fetch.create({
    ignoreResponseError: false,
    onResponseError: async (context) => {
      await handleMagentoFetchAuthError(context);
    }
  });
});
